import { useState, useRef, useCallback } from 'react';

/**
 * useIconPicker Hook
 * 
 * Handles icon picker state and positioning logic
 */
export const useIconPicker = ({ taskId, onIconChange }) => {
  const [showIconPicker, setShowIconPicker] = useState(false);
  const [iconPickerPosition, setIconPickerPosition] = useState(null);
  const iconButtonRef = useRef(null);

  const handleIconClick = useCallback((e) => {
    e.stopPropagation();
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const menuHeight = 420;
    const menuWidth = 320;
    
    if (iconButtonRef.current) {
      const rect = iconButtonRef.current.getBoundingClientRect();
      let top = rect.bottom + 4;
      if (top + menuHeight > viewportHeight) {
        top = rect.top - menuHeight - 4;
      }
      let left = rect.left;
      if (left + menuWidth > viewportWidth) {
        left = viewportWidth - menuWidth - 10;
      }
      setIconPickerPosition({ x: left, y: top });
    }
    setShowIconPicker(true);
  }, []);

  const handleIconChange = useCallback((newIcon) => {
    onIconChange?.(taskId, newIcon);
    // Don't close picker - let user set both icon and color
  }, [onIconChange, taskId]);

  const closeIconPicker = useCallback(() => {
    setShowIconPicker(false);
  }, []);

  return {
    showIconPicker,
    iconPickerPosition,
    iconButtonRef,
    handleIconClick,
    handleIconChange,
    closeIconPicker,
  };
};

export default useIconPicker;
